module.exports = __webpack_public_path__ + "img/crown.5a0db00d.png";